module.exports = __webpack_public_path__ + "static/img/case-2caibao.5d6cfb55.jpg";